export default __webpack_public_path__ + "static/media/doug-wade-space-is-closer-than-you-think.b8c3135b.jpg";